import { render, staticRenderFns } from "./DispatchReturns.vue?vue&type=template&id=1f604dee"
import script from "./DispatchReturns.vue?vue&type=script&lang=js"
export * from "./DispatchReturns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports